import React from 'react';
import { Modal, Table, Tag } from 'antd';
import { getSignalTypeLabel } from './utils';

const LinkedSignalsModal = ({ open, onCancel, signalLinks, strategyName }) => {
  const columns = [
    {
      title: 'Signal Name',
      dataIndex: 'name',
      key: 'name',
      align: "left",
      render: (text) => <span style={{fontSize: '12px'}}>{text || 'N/A'}</span> ,
    },
    {
      title: 'Signal Type',
      dataIndex: 'type',
      key: 'type',
      align: 'center',
      render: (type) => <Tag color="blue">{getSignalTypeLabel(type)}</Tag>,
    },
    {
      title: 'Multiplier',
      dataIndex: 'multiplier',
      key: 'multiplier',
      align: 'right',
      render: (val) => <span style={{fontSize: '12px'}}>{val || 1}</span>,
    }
  ];

  return (
    <Modal
      title={`Linked Signals ${strategyName ? `- ${strategyName}` : ''}`}
      onCancel={onCancel}
      open={open}
      footer={null}
      width={600}
    >
      <div className="quiktrade-algo">
        <Table
          dataSource={signalLinks}
          columns={columns}
          pagination={false}
          size="small"
          scroll={{ x: true }}
          rowKey={(record, index) => index}
        />
      </div>
    </Modal>
  );
};

export default LinkedSignalsModal;
